import React, {useMemo} from 'react';
import PropTypes from 'prop-types';
import {Box, Heading, Text, Link, Button} from '@spothero/ui';
import IconLocationArrow from '@spothero/icons/location-arrow';
import {PROPTYPE_RESERVATION_FACILITY} from '@/proptypes/reservation-prop-types';

const DEFAULT_VEHICLE_ENTRANCE = 'default-vehicle-entrance';

const GettingThere = ({facility, onTrackedClick}) => {
    const {gettingHere, addresses} = facility;
    const formattedGettingHere = gettingHere.replace(/\r?\n/g, '<br>');
    const entranceAddress = useMemo(
        () =>
            addresses.find(address => {
                return address.types.includes(DEFAULT_VEHICLE_ENTRANCE);
            }),
        [addresses]
    );

    const transformedAddress = `${entranceAddress.latitude}%2C${entranceAddress.longitude}`;
    const mapLink = `https://www.google.com/maps/search/?api=1&query=${transformedAddress}`;

    return (
        <>
            <Heading as="h2" marginBottom={3}>
                Getting There
            </Heading>
            {entranceAddress.streetAddress ? (
                <>
                    <Text fontWeight="semibold">Enter At:</Text>
                    <Link
                        href={mapLink}
                        onClick={() =>
                            onTrackedClick({
                                clickTarget: 'Enter At Link',
                                isReservationChange: false,
                            })
                        }
                        isExternal
                        rel="noopener noreferrer"
                        marginBottom={6}
                        display="inline-block"
                        fontSize="base"
                    >
                        {entranceAddress.streetAddress}, {entranceAddress.city},{' '}
                        {entranceAddress.state}
                    </Link>
                </>
            ) : null}
            <Box
                marginBottom={6}
                fontSize="base"
                dangerouslySetInnerHTML={{__html: formattedGettingHere}}
            />
            <Button
                variant="secondary"
                href={mapLink}
                onClick={() =>
                    onTrackedClick({
                        clickTarget: 'Navigate There',
                        isReservationChange: false,
                    })
                }
                asAnchor
                isExternal
                leftIcon={
                    <IconLocationArrow height="1.125rem" width="1.125rem" />
                }
                textTransform="auto"
                width={{base: '100%', tablet: 'auto'}}
                alignSelf={{base: 'auto', tablet: 'start'}}
                sx={{
                    '@media print': {
                        display: 'none',
                    },
                }}
            >
                Navigate There
            </Button>
        </>
    );
};

GettingThere.propTypes = {
    facility: PROPTYPE_RESERVATION_FACILITY,
    onTrackedClick: PropTypes.func.isRequired,
};

export default GettingThere;
